var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.56,7.82,25,1.65a.48.48,0,0,0-.44-.3.48.48,0,0,0-.19,0L20.62,3l3,2.37a2,2,0,0,1,.76,1.34,2,2,0,0,1-.2,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,5.06A2,2,0,0,1,17,6.17a2,2,0,0,1,0,1.54l0,.11h5.34l.48-.61a.48.48,0,0,0-.08-.68L14.46.1a.48.48,0,0,0-.68.08l-2.31,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.35,6.47,5.75,2.35a.48.48,0,0,0-.19,0,.48.48,0,0,0-.44.29L2.88,7.82H15.29l.31-.72a.48.48,0,0,0-.25-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.66,10.36a1.4,1.4,0,0,0-1.06-.48H1.4A1.4,1.4,0,0,0,0,11.47L1.66,22.82A1.4,1.4,0,0,0,3,24H27a1.4,1.4,0,0,0,1.39-1.2L30,11.47A1.41,1.41,0,0,0,29.66,10.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsContent);
export default __webpack_public_path__ + "static/media/icon-tutorials-content.fd52d0a032d535f6f8c91c0a097a23ce.svg";
export { ForwardRef as ReactComponent };